import { Typography } from 'antd'
import styled from 'styled-components'

const StyledUnknownWordsSortByText = styled(Typography.Text)`
  margin-left: 1rem;
`

export default StyledUnknownWordsSortByText
